<template>
  <div class="legal-page">
    <div class="legal-container">
      <!-- Hero Section -->
      <div class="legal-hero">
        <h1>About REGIIS COSMETICS</h1>
        <p class="lead">Your trusted online shopping destination for quality products</p>
      </div>

      <!-- Main Content -->
      <div class="legal-content">
        <!-- Our Story -->
        <section class="legal-section">
          <h2>Our Story</h2>
          <p>Founded with a vision to revolutionize online shopping in Nigeria, REGIIS COSMETICS has grown from a small startup to one of the region's most trusted e-commerce platforms. We believe that everyone deserves access to quality products at fair prices, delivered with exceptional service.</p>
          <p>Our journey began with a simple question: "How can we make online shopping easier, safer, and more enjoyable?" Today, we continue to answer that question by constantly improving our platform, expanding our product range, and listening to our customers.</p>
        </section>

        <!-- Our Mission -->
        <section class="legal-section">
          <h2>Our Mission</h2>
          <p>To provide customers with a seamless shopping experience by offering:</p>
          <ul>
            <li><strong>Quality Products:</strong> We carefully select every item in our catalog to ensure it meets our high standards</li>
            <li><strong>Competitive Prices:</strong> We work directly with suppliers to bring you the best value</li>
            <li><strong>Fast Delivery:</strong> Your order is our priority, and we strive to get it to you quickly and safely</li>
            <li><strong>Outstanding Service:</strong> Our customer support team is always ready to help you</li>
          </ul>
        </section>

        <!-- Why Choose Us -->
        <section class="legal-section">
          <h2>Why Choose REGIIS COSMETICS?</h2>
          <div class="feature-grid">
            <div class="feature-card">
              <div class="feature-icon">🛡️</div>
              <h3>Secure Shopping</h3>
              <p>Your data is protected with industry-standard encryption and security measures</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">✓</div>
              <h3>Verified Products</h3>
              <p>All products are sourced from trusted suppliers and verified for authenticity</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">🚚</div>
              <h3>Reliable Delivery</h3>
              <p>We partner with leading logistics companies to ensure timely delivery</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">💬</div>
              <h3>24/7 Support</h3>
              <p>Our customer service team is available around the clock to assist you</p>
            </div>
          </div>
        </section>

        <!-- Our Values -->
        <section class="legal-section">
          <h2>Our Values</h2>
          <div class="values-list">
            <div class="value-item">
              <h3>Customer First</h3>
              <p>Every decision we make is guided by what's best for our customers</p>
            </div>
            <div class="value-item">
              <h3>Integrity</h3>
              <p>We conduct our business with honesty, transparency, and ethical practices</p>
            </div>
            <div class="value-item">
              <h3>Innovation</h3>
              <p>We continuously seek new ways to improve and enhance the shopping experience</p>
            </div>
            <div class="value-item">
              <h3>Quality</h3>
              <p>We never compromise on the quality of products or services we provide</p>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
